import { forwardRef } from 'react';
import { Link } from 'react-router';
import classNames from 'clsx';

import type { LinkProps } from 'react-router';
import type { UIButtonVariant } from 'types/UserInterface';

import styles from './Button.module.css';

export interface LinkButtonProps extends Omit<LinkProps, 'className' | 'style'> {
  /** The variant of the button. */
  variant: UIButtonVariant;
}

/** Represents a button that is used as a Link within react-router.
 *
 *  Only works when rendered inside a 'react-router' BrowserRouter
 */
export const LinkButton = forwardRef<HTMLAnchorElement, LinkButtonProps>(
  ({ variant, ...restProps }: LinkButtonProps, forwardedRef) => {
    return (
      <Link {...restProps} className={classNames(styles['button'], styles[`button--${variant}`])} ref={forwardedRef} />
    );
  }
);
